import { SYSTEM_ROLES } from './roles.config';

export const fieldVisibilityConfig = {
    extraFilter: [SYSTEM_ROLES.ADMIN],
    commissionAgentJson: [SYSTEM_ROLES.ADMIN], //the list of roles can be merchant, psp, agent too
    commissionMerchantJson: [SYSTEM_ROLES.ADMIN],
    commissionGwJson: [SYSTEM_ROLES.ADMIN],
    systemAccount: [SYSTEM_ROLES.ADMIN],
    terminalGateway: [SYSTEM_ROLES.ADMIN],
    merchantTerminal: [SYSTEM_ROLES.ADMIN],
    totalPaymentsBalance: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    totalPayoutsBalance: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    totalFees: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    totalDepositsBalance: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    totalWithdrawalsBalance: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    currentBalance: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    totalAgentCommission: [SYSTEM_ROLES.ADMIN],
    totalIncludedCommission: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.MERCHANT],
    totalOntopCommission: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.MERCHANT],
    totalIncludedCommissionGwCost: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP],
    totalOntopCommissionGwCost: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP],
    cascadingStatus: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.PSP, SYSTEM_ROLES.AGENT],
    originalPaymentId: [SYSTEM_ROLES.ADMIN],
    internalStateDescription: [SYSTEM_ROLES.ADMIN],
    ecomCascadeRule: [SYSTEM_ROLES.ADMIN],
    p2pCascadeRule: [SYSTEM_ROLES.ADMIN],
    payoutCascadeRule: [SYSTEM_ROLES.ADMIN],
    redirectCascadeRule: [SYSTEM_ROLES.ADMIN],
};
